import { render, staticRenderFns } from "./typeHospitalization.vue?vue&type=template&id=34e7a849&"
import script from "./typeHospitalization.vue?vue&type=script&lang=js&"
export * from "./typeHospitalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports